import { MockHook, LANDING_PATH } from '@jupiterone/jupiter-web-toolkit';
import { useHistory } from 'react-router-dom';
export interface ContainerInfoProps {
  handleSearchAnywhereClose: VoidFunction;
}
const useContainerInfoLogic = ({
  handleSearchAnywhereClose,
}: ContainerInfoProps) => {
  const history = useHistory();
  const handleAdvancedViewClick = () => {
    history.push(LANDING_PATH);
    handleSearchAnywhereClose();
  };

  const handleQueryLibraryClick = () => {
    history.push('/landing?openLibrary=true');
    handleSearchAnywhereClose();
  };
  return {
    handleAdvancedViewClick,
    handleQueryLibraryClick,
  };
};

export type ContainerInfoComponentProps = ReturnType<
  typeof useContainerInfoLogic
>;
export const MOCK_CONTAINER_INFO_PROPS: ContainerInfoComponentProps = {
  handleAdvancedViewClick: MockHook.mockFunction,
  handleQueryLibraryClick: MockHook.mockFunction,
};
export default MockHook.useMockHook(
  useContainerInfoLogic,
  MOCK_CONTAINER_INFO_PROPS
);
